import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import { Theme } from '@mui/material/styles';
import {
	Tabs,
	Tab,
	Box,
	TextField,
	Button,
	Badge,
	FormHelperText,
} from '@mui/material';
import { Row, Col } from 'reactstrap';
import defaultProfileIcon from '../../images/UserProfile.svg';
import * as utils from '../../util/bellplus-utils';
import shortid from 'shortid';
// import { getUserrDetails } from '../../services/userprofile.services'
import {
	updateUserDetails,
	updateUserCredentials,
} from '../../services/userProfile.services';
import cameraIcon from 'images/cameraIcon.png';
import { uploadAsset } from 'services/template.service';
import { validateSchema } from 'validations/common';
import {
	userProfileValidationSchema,
	userCredentialsValidateSchema,
} from 'validations/userprofile.validation';
import theme from 'theme';
import { useAppDispatch } from 'Stores/Hooks/hooks';
import { SEND_MESSAGE } from 'Stores/Slices/errorHandlingSlice';
import { CssTextField } from 'views/Common/CssTextField';

const PREFIX = 'UserProfile';

const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`,
    tabs: `${PREFIX}-tabs`,
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    textInput: `${PREFIX}-textInput`,
    textInputLabel: `${PREFIX}-textInputLabel`,
    tr: `${PREFIX}-tr`,
    uploadInput: `${PREFIX}-uploadInput`,
    saveButton: `${PREFIX}-saveButton`,
};

const Root = styled('div')((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: 670,
        margin:'10px'
    },

    [`& .${classes.paper}`]: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },

    [`& .${classes.tabs}`]: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '17%',
    },

    [`& .${classes.formControl}`]: {
        minWidth: 120,
        textAlign: 'left',
        marginBottom:'-10px',
    },

    [`& .${classes.selectEmpty}`]: {},

    [`& .${classes.textInput}`]: {
        height: 50,
        marginBottom:'-10px',
    },

    [`& .${classes.textInputLabel}`]: {
        fontSize: '1rem',
        lineHeight: 1,
    },

    [`& .${classes.tr}`]: {
        background: '#f1f1f1',
        '&:hover': {
            background: '#f00',
        },
    },

    [`& .${classes.uploadInput}`]: {
        display: 'none',
    },
    [`& .${classes.saveButton}`]: {
      marginTop:'20px',
      backgroundColor:'#042630'
    }
}));

interface TabPanelProps {
	children?: React.ReactNode;
	index: any;
	value: any;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
        <Root
			style={{ width: '86%' }}
			role="tabpanel"
			hidden={value !== index}
			id={`vertical-tabpanel-${index}`}
			aria-labelledby={`vertical-tab-${index}`}
			{...other}>
			{value === index && (
				<Box p={3}>
					<div>{children}</div>
				</Box>
			)}
		</Root>
    );
}

function a11yProps(index: any) {
	return {
		id: `vertical-tab-${index}`,
		'aria-controls': `vertical-tabpanel-${index}`,
	};
}

interface UserProfile {
	id: number;
	firstName: string;
	lastName: string;
	username: string;
	phoneNumber: number;
	state: string;
	city: string;
	pinCode: number;
	address: string;
	emailId: string;
	confirmEmailId: string;
	password: string;
	companyName: string;
	panNumber: string;
	gstNumber: string;
	businessCategoryId: number;
	profilePicUrl: string;
	profilePicId: number;
}
const empytUserP: UserProfile = {
	id: 0,
	firstName: '',
	lastName: '',
	username: '',
	phoneNumber: 0,
	state: '',
	city: '',
	pinCode: 0,
	address: '',
	emailId: '',
	confirmEmailId: '',
	password: '',
	companyName: '',
	panNumber: '',
	gstNumber: '',
	businessCategoryId: 0,
	profilePicUrl: '',
	profilePicId: 0,
};

const UserProfile = () => {
	const [userDetails, setUserDetails] = useState<UserProfile>(empytUserP);
	const [currentPassword, setCurrentPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [alertCurentPassword, setAlertCurentPassword] = useState(false);
	const [alertMismatchPassword, setAlertMismatchPassword] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const fileid: string = shortid.generate();
	const [selectedFile, setSelectedFile] = useState();
	const [errorObj, setErrorObj] = useState<any>({});
	const imageAcceptString = 'image/*';
	const [, setProfileId] = useState('');
	const [preview, setPreview] = useState<any>();
	// const dispatch = useDispatch();\
  const dispatch = useAppDispatch();

	useEffect(() => {
		if (!selectedFile) {
			setPreview(undefined);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		// 	// free memory when ever this component is unmounted
		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const handleClick = (input: string) => {
		switch (input) {
			case 'wrong password':
				setAlertCurentPassword(true);
				break;
			case 'mismatch password':
				setAlertCurentPassword(false);
				setAlertMismatchPassword(true);
				break;
			case 'empty password':
				setAlertCurentPassword(true);
				break;
			default:
				break;
		}
	};

	const upload = (e: any) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		// I've kept this example simple by using the first image instead of multiple
		setSelectedFile(e.target.files[0]);
		uploadImage(e.target.files[0]);
	};

	const uploadImage = async (data: any) => {
		const file = data;
		if (
			file !== undefined &&
			file !== null &&
			file.size !== undefined &&
			file.size !== null &&
			file.size
		) {
			const formData = new FormData();
			formData.append('file', file);

			const imageResp: any = await uploadAsset(file, 'userProfile');
			if (imageResp.data.data !== 0) {
				setProfileId(imageResp.data.data.id);
				updateUserProfile({ profilePicId: imageResp.data.data.id });
			}
		}
	};

	useEffect(() => {
		let userDetails: UserProfile;

		const data: any = localStorage.getItem('userDetails');
		const dataCredentials: any = localStorage.getItem('userCredentials');
		userDetails = JSON.parse(data).data;
		const userCredentials: UserProfile = JSON.parse(dataCredentials);
		userDetails = { ...userDetails, ...userCredentials };

		if (
			userDetails.profilePicUrl === null ||
			(userDetails.profilePicUrl && userDetails.profilePicUrl.length === 0)
		) {
			userDetails.profilePicUrl = defaultProfileIcon;
			setUserDetails(userDetails);
		} else {
			setUserDetails(userDetails);
		}
	}, []);

	const UpdateDetails = async (input: any) => {
		const {
			firstName,
			lastName,
			emailId,
			confirmEmailId,
			pinCode,
			phoneNumber,
			address,
			state,
			city,
			gstNumber,
			profilePicId,
			companyName,
			// businessCategoryId,
		} = input;
		const updateUserInput = {
			firstName,
			lastName,
			emailId,
			confirmEmailId,
			pinCode,
			phoneNumber,
			companyName,
			address,
			state,
			city,
			gstNumber,
			profilePicId,
			// businessCategoryId,
		};
		const updatedUserInput = { ...updateUserInput, businessCategory: '1' };
		validateSchema(userProfileValidationSchema, updateUserInput)
			.then(async () => {
				try {
					const resp: any = await updateUserDetails(
						input.clientId,
						updatedUserInput,
					);

					const data: any = localStorage.getItem('userDetails');
					const userDetails = JSON.parse(data).data;
					const jsonData = JSON.parse(data);
					const updateDetails = {
						...userDetails,
						profilePicUrl: resp.data.data.profilePicUrl,
					};
					const updatedDetails = {
						...jsonData,
						data: updateDetails,
					};
					// history.push(routes.USER_PROFILE.path);
					utils.setData('userDetails', updatedDetails);
					setErrorObj({});
					// dispatch(sendMessage('Profile Updated Successfully', 'success'));
          dispatch(SEND_MESSAGE({ message: 'Profile Updated Successfully', type:'success' }));
				} catch (error:any) {
					console.warn('error', error);
          dispatch(SEND_MESSAGE({ message: error, type:'error' }));

				}
			})
			.catch((error) => {
				setErrorObj(error);
			});
	};

	const handleUpdateUser = () => {
		UpdateDetails(userDetails);
	};

	const handleUserCredentials = (input: any) => {
		const userCred = {
			currentPassword: currentPassword,
			password: newPassword,
			confirmPassword: confirmPassword,
			id: input.clientId,
		};

		UpdateCredentialsDetails(userCred);
	};

	const UpdateCredentialsDetails = async (input: any) => {
		const { id, ...newInput } = input;
		validateSchema(userCredentialsValidateSchema, input)
			.then(async () => {
				try {
					await updateUserCredentials(newInput);
          dispatch(SEND_MESSAGE({ message: 'Password Updated Successfully', type:'success' }));
					setErrorObj({});
					setNewPassword('');
					setCurrentPassword('');
					setConfirmPassword('');
				} catch (error:any) {
					console.warn('error', error);
          dispatch(SEND_MESSAGE({ message: error, type:'error' }));

				}
			})
			.catch((error) => {
				setErrorObj(error);
				console.warn('catch error', error);
			});
	};

	const handleUpdateUserCredentials = () => {
		if (currentPassword.length !== 0) {
			if (newPassword.length >= 4) {
				if (newPassword === confirmPassword) {
					setAlertMismatchPassword(false);
					handleUserCredentials(userDetails);
				} else {
					setSnackbarMessage('Password does not match');
					handleClick('mismatch password');
				}
			} else {
				setSnackbarMessage('Password should be atleast 4 characters');
				handleClick('mismatch password');
			}
		} else {
			setSnackbarMessage('Enter Password');
			handleClick('empty password');
		}
		// return null
	};


	const [value, setValue] = React.useState(0);

	const updateUserProfile = (user: Partial<UserProfile>) => {
		const updatedProfile: UserProfile = { ...userDetails, ...user };
		setUserDetails(updatedProfile);
	};

	const handleOnChange = (event: any) => {
		const name: string = event.target.name;
		const value: any = event.target.value;

		switch (name) {
			case 'firstName':
				updateUserProfile({ firstName: value });
				break;
			case 'lastName':
				updateUserProfile({ lastName: value });
				break;
			case 'userName':
				updateUserProfile({ username: value });
				break;
			case 'phoneNumber':
				updateUserProfile({ phoneNumber: value });
				break;
			case 'state':
				updateUserProfile({ state: value });
				break;
			case 'city':
				updateUserProfile({ city: value });
				break;
			case 'zipCode':
				updateUserProfile({ pinCode: value });
				break;
			case 'address':
				updateUserProfile({ address: value });
				break;
			case 'emailAddress':
				updateUserProfile({ emailId: value });
				break;
			case 'confirmEmailAddress':
				updateUserProfile({ confirmEmailId: value });
				break;
			case 'companyName':
				updateUserProfile({ companyName: value });
				break;
			case 'gstNumber':
				updateUserProfile({ gstNumber: value });
				break;
			case 'panNumber':
				updateUserProfile({ panNumber: value });
				break;
			case 'oldPassword':
				setCurrentPassword(value);
				break;
			case 'newPassword':
				setNewPassword(value);
				break;
			case 'confirmPassword':
				setConfirmPassword(value);
				break;
			default:
				break;
		}
	};

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue);
	};

	return (
    <Root>
        <div className={classes.root}>
			<ToastsContainer
				className="toast"
				store={ToastsStore}
				position={ToastsContainerPosition.TOP_CENTER}
			/>
			<Tabs
				orientation="vertical"
				variant="scrollable"
				value={value}
				onChange={handleChange}
				aria-label="Vertical tabs example"
				className={classes.tabs}
        textColor='inherit'
        TabIndicatorProps={{
          style: {
            backgroundColor: theme.palette.secondary.main,
          }
        }}
        >
				<Tab label="User Profile" {...a11yProps(0)} />
				<Tab label="Security" {...a11yProps(1)} />
				{/* <Tab label="Settings" {...a11yProps(2)} /> */}
			</Tabs>
			<TabPanel value={value} index={0}>
				<div
					style={{
						height: '8rem',
						textAlign: 'center',
						margin: '10px auto',
						width: '8rem',
					}}>
					<Badge
						overlap="circular"
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right',
						}}
						badgeContent={
							<div>
								<input
									className={classes.uploadInput}
									id={fileid}
									onChange={upload}
									type="file"
									accept={imageAcceptString}
								/>
								<label htmlFor={fileid}>
									<img
										// variant="contained"
										// startIcon={<PhotoCameraIcon />}
										// color="primary"
										// component="span"
										// className={classes.btnStyle}
										//   disabled={disabled}
										style={{ width: '2rem', cursor: 'pointer' }}
										src={cameraIcon}
										alt="camera icon"
									/>
								</label>
							</div>
						}>
						{selectedFile === undefined ? (
							<img
								src={userDetails.profilePicUrl}
								alt="shows user profile"
								style={{
									height: '8rem',
									textAlign: 'center',
									margin: '0px auto',
									width: '8rem',
									borderRadius: '10rem',
								}}
							/>
						) : (
							<img
								src={preview}
								alt="preview"
								style={{
									height: '8rem',
									textAlign: 'center',
									margin: '0px auto',
									width: '8rem',
									borderRadius: '10rem',
								}}
							/>
						)}
					</Badge>
				</div>
				<div>
					<Row className={classes.formControl}>
						<Col lg="6" md="6" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="First Name"
								name="firstName"
								value={userDetails.firstName}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.firstName}
							</FormHelperText>
						</Col>
						<Col lg="6" md="6" sm="12" xs="12">
							<CssTextField
								value={userDetails.lastName}
								onChange={handleOnChange}
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								name="lastName"
								label="Last Name"
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.lastName}
							</FormHelperText>
						</Col>
						<Col lg="4" md="4" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="Email Address"
								name="emailAddress"
								value={userDetails.emailId}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.emailId}
							</FormHelperText>
						</Col>
						<Col lg="4" md="4" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="Confirm Email Address"
								name="confirmEmailAddress"
								value={userDetails.confirmEmailId}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.confirmEmailId}
							</FormHelperText>
						</Col>
						<Col lg="4" md="4" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="Phone Number"
								name="phoneNumber"
								value={userDetails.phoneNumber}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.phoneNumber}
							</FormHelperText>
						</Col>
					</Row>
					<Row  className={classes.formControl}>
						<Col lg="4" md="4" sm="12" xs="12">
							<CssTextField
								value={userDetails.companyName}
								onChange={handleOnChange}
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								name="companyName"
								label="Company Name"
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.companyName}
							</FormHelperText>
						</Col>
						<Col lg="4" md="4" sm="12" xs="12">
							<CssTextField
								value={userDetails.gstNumber}
								onChange={handleOnChange}
								variant="outlined"
								margin="normal"
								fullWidth
								autoComplete="off"
								name="gstNumber"
								label="GST Number"
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.gstNumber}
							</FormHelperText>
						</Col>
						<Col lg="4" md="4" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								fullWidth
								autoComplete="off"
								label="Business Category"
								name="businessCategory"
								// value={userDetails.panNumber}
								// onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
								disabled={true}
							/>
							{/* <FormHelperText error={true}>
								{errorObj.businessCategory}
							</FormHelperText> */}
						</Col>
					</Row>
					<Row  className={classes.formControl}>
						<Col lg="4" md="6" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="State"
								name="state"
								value={userDetails.state}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>{errorObj.state}</FormHelperText>
						</Col>
						<Col lg="4" md="6" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="City"
								name="city"
								value={userDetails.city}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>{errorObj.city}</FormHelperText>
						</Col>
						<Col lg="4" md="6" sm="12" xs="12">
							<CssTextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								label="Zipcode"
								name="zipCode"
								value={userDetails.pinCode}
								onChange={handleOnChange}
								InputProps={{
									className: classes.textInput,
								}}
								InputLabelProps={{
									className: classes.textInputLabel,
								}}
							/>
							<FormHelperText error={true}>
								{errorObj.pinCode}
							</FormHelperText>
						</Col>
						<Col lg="12" md="12" sm="12" xs="12">
							<CssTextField
								value={userDetails.address}
								onChange={handleOnChange}
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoComplete="off"
								name="address"
								label="Address"
								multiline
								maxRows={3}
							/>
							<FormHelperText error={true}>
								{errorObj.address}
							</FormHelperText>
						</Col>
					</Row>
					<div style={{ textAlign: 'right' }}>
						<Button
							variant="contained"
							color="primary"
              className={classes.saveButton}
							onClick={handleUpdateUser}>
							save
						</Button>
					</div>
				</div>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<Row>
					<Col lg="12" md="12" sm="12" xs="12">
						<CssTextField
							error={alertCurentPassword}
							helperText={alertCurentPassword ? snackbarMessage : null}
							value={currentPassword}
							onChange={handleOnChange}
							variant="outlined"
							margin="normal"
							type="password"
							required
							fullWidth
							autoComplete="off"
							name="oldPassword"
							label="Old Password"
						/>
					</Col>
				</Row>
				<Row>
					<Col lg="6" md="6" sm="12" xs="12">
						<CssTextField
							error={alertMismatchPassword}
							helperText={alertMismatchPassword ? snackbarMessage : null}
							value={newPassword}
							onChange={handleOnChange}
							variant="outlined"
							margin="normal"
							required
							fullWidth
							autoComplete="off"
							name="newPassword"
							label="Password"
							type="password"
							id="password"
						/>
						<FormHelperText error={true}>{errorObj.password}</FormHelperText>
					</Col>
					<Col lg="6" md="6" sm="12" xs="12">
						<CssTextField
							error={alertMismatchPassword}
							helperText={alertMismatchPassword ? snackbarMessage : null}
							value={confirmPassword}
							onChange={handleOnChange}
							variant="outlined"
							margin="normal"
							required
							fullWidth
							autoComplete="off"
							name="confirmPassword"
							label="Confirm Password"
							type="password"
							id="confirmPassword"
						/>
						<FormHelperText error={true}>
							{errorObj.confirmPassword}
						</FormHelperText>
					</Col>
				</Row>
				<div style={{ textAlign: 'right' }}>
					<Button
						variant="contained"
						color="primary"
						onClick={handleUpdateUserCredentials}
            className={classes.saveButton}
            >
						save
					</Button>
				</div>
			</TabPanel>
			{/* <TabPanel value={value} index={2}>
        Settings
      </TabPanel> */}
		</div>
    </Root>
    );
};

export default UserProfile;
